<template>
  <Layout>
    <div class="d-flex login-container justify-content-center align-items-center">
      <b-card class="login-box">
        <div class="box-title mb-4">Log in your account</div>

        <div
          v-if="isShowError"
          class="alert alert-danger alert-outline alert-dismissible fade show fw-600"
          role="alert"
        >
          <i class="uil uil-exclamation-octagon font-size-16 text-danger me-2"></i>
          {{ errorMessage }}

          <template v-if="errorMessage == 'User does not exist.'">
            <span class="d-block mt-2 green-link" @click="showAccountUnavailable" role="button" style="cursor:pointer">
              Create your account
            </span>
          </template>
          <button type="button" class="btn-close" @click="closeError"></button>
        </div>

        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form ref="loginForm" @submit.prevent="handleSubmit(login)" @reset.prevent="reset">
            <b-form-group class="mb-4" label="Email Address">
              <validation-provider name="email address" rules="required|email" v-slot="validationContext">
                <b-form-input
                  :state="getValidationState(validationContext)"
                  placeholder="Enter Email Address"
                  v-model="username"
                  trim
                ></b-form-input>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>

            <b-form-group class="mb-2" label="Password">
              <validation-provider
                name="password"
                rules="required"
                v-slot="validationContext"
              >
                <b-input-group>
                  <template #append>
                    <b-input-group-text
                      class="toggle-password"
                      :class="{
                        'input-text-red':
                          getValidationState(validationContext) === false,
                        'input-text-green':
                          getValidationState(validationContext) === true,
                      }"
                      @click="
                        () => (isShowPassword = !isShowPassword)
                      "
                      >&nbsp;<i
                        class="far"
                        :class="{
                          'fa-eye': isShowPassword,
                          'fa-eye-slash': !isShowPassword,
                        }"
                      ></i
                    ></b-input-group-text>
                  </template>
                  <b-form-input
                    class="no-border-right"
                    :type="isShowPassword ? 'text' : 'password'"
                    :state="getValidationState(validationContext)"
                    placeholder="Enter Password"
                    v-model="password"
                    trim
                  ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
            <div class="mb-4">
              <router-link :to="{ name: 'forgot-password', params: { email: username } }"
                >Forgot Password?</router-link
              >
            </div>
            <b-button
              class="w-100 mb-3"
              type="submit"
              variant="primary"
              :disabled="isLoginLoading"
            >
              <span
                v-if="isLoginLoading"
                class="spinner-grow spinner-grow-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Login
            </b-button>

            <div class="mb-4">
              Don't have an account yet?
              <a style="color: rgba(var(--bs-link-color-rgb)); cursor: pointer;" @click="showAccountUnavailable">Create your account</a>
            </div>
            <chat-support />
          </b-form>
        </ValidationObserver>
      </b-card>

      <account-creation-unavailable-modal ref="accountModal" />
    </div>
    <!-- <toast type="success" v-if="showToast" @close="() => showToast = false" title="Password Changed" message="Your password has been changed successfully.<br/>
You can now log in with your new password." /> -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import { authMethods } from "@/state/helpers";
import { Auth } from "aws-amplify";
import AccountCreationUnavailableModal from '@/components/AccountCreationUnavailableModal.vue';

export default {
  data() {
    return {
      showToast: false,
      isShowPassword: false,
      isLoginLoading: false,
      isShowError: false,
      errorMessage: "",
      username: null,
      password: null,
    };
  },
  components: {
    Layout,
    AccountCreationUnavailableModal,
  },
  methods: {
    ...authMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    closeError() {
      this.isShowError = false;
    },
    login() {
      this.isLoginLoading = true;
      this.isShowError = false;
      this.errorMessage = null;

      this.logIn({
        username: this.username,
        password: this.password,
      })
        .then(async (user) => {
          this.isLoginLoading = false;
          this.isShowError = false;
          this.errorMessage = null;

          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            await Auth.completeNewPassword(
              user, // the Cognito User Object
              this.password, // the new password
              {
                phone_number: '+639190000000'
              }
            );
          }
        })
        .catch((err) => {
          this.isLoginLoading = false;
          this.isShowError = true;
          this.errorMessage = err.message;
        });
    },

    showAccountUnavailable() {
      if (this.$refs && this.$refs.accountModal && typeof this.$refs.accountModal.show === 'function') {
        this.$refs.accountModal.show();
      }
    },
  },
  mounted() {
    var changePassword = this.$route.query.changePassword;

    if (parseInt(changePassword) === 1) {
      this.$toast.showToast('info', 'Password Changed', 'Your password has been changed successfully.<br/>You can now log in with your new password.');
      this.$router.replace({ query: null });
    }
  },
};
</script>

<style>
@media screen and (min-width: 320px) and (max-width: 768px) {
  .login-container {
    margin-top: 70px !important;
  }
}

.login-box {
  width: 493px;
  border-radius: 8px;
}

.login-box .card-body {
  padding: 24px;
}

.login-box legend {
  font-weight: 500;
  font-family: "Poppins";
}

.login-container {
  height: 80vh;
}

.login-container h3 {
  font-family: "Poppins";
}

.swal2-close {
  color: #000;
}

.swal2-title,
.swal2-html-container {
  color: #000 !important;
}

.no-border-right {
  border-right: none;
}

.input-text-green {
  border-color: #51d28c;
}

.input-text-red {
  border-color: #f34e4e;
}

.toggle-password {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  cursor: pointer;
  background: none;
  color: #e1e1e1;
}

.green-link {
  color: #79A861 !important;
}

.account-svg {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  cursor: pointer;
}
.account-svg svg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
